import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Category from "../components/Category";
import Sunglassess from "../components/Sunglassess";
import FullFrame from "../components/FullFrame";
import HalfFrame from "../components/HalfFrame";
import DMF from "../components/DMF";
import FrameLess from "../components/FrameLess";
import SafetyGlasses from "../components/SafetyGlasses";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getFirestore, collection, getDocs, query, where, setDoc, doc, limit } from "firebase/firestore";
import im6 from "../assets/images/im6.png";
import im7 from "../assets/images/im7.png";
import im8 from "../assets/images/im8.png";
import im9 from "../assets/images/im9.jpeg";
import im10 from "../assets/images/im10.jpeg";
import im11 from "../assets/images/im11.png";
import im12 from "../assets/images/im12.png";
import im13 from "../assets/images/im13.png";
import im14 from "../assets/images/im14.jpg";
import im15 from "../assets/images/im15.png";
import im16 from "../assets/images/im16.png";
import im17 from "../assets/images/im17.png";
import im33 from "../assets/images/im33.jpg";
import Accessories from "../components/Accessories";
import KidsFrame from "../components/KidsFrame";
import KidsSungless from "../components/KidsSungless";

const brand = [im6, im7, im8, im9, im10, im11, im12, im13, im14, im15, im16, im17];
const brands = [
  "Zeiss",
  "Essilor",
  "Rodenstock",
  "Vision Rx",
  "Nova",
  "Kodak",
  "Vogue",
  "Tom Ford",
  "Ray-Ban",
  "Carrera",
  "Police",
  "Boss",
  "Mont Blanc"
];
const collections = [
  "DesignerMetal&MetalFrame",
  "DesignerMetal_MetalFrame",
  "Accessories",
  "FrameLess",
  "FullFrame",
  "HalfFrame",
  "Kids-Frame",
  "Kids-Sunglass",
  "LDB",
  "SafetyGlassess",
  "Sunglassess",
  "Types"
];
const images = [im9, im10, im33];

// Custom debounce function
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export default function Products() {
  const [showPopup, setShowPopup] = useState(false);
  const [phone, setPhone] = useState("");
  const [username, setUsername] = useState("");
  const [user, setUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const db = getFirestore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    }
  }, [user]);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLoginSignup = async () => {
    if (!phone || !username) {
      alert("Please enter both phone number and username.");
      return;
    }

    try {
      const userQuery = query(collection(db, "UDB"), where("phone", "==", phone));
      const querySnapshot = await getDocs(userQuery);

      if (!querySnapshot.empty) {
        const userData = querySnapshot.docs[0].data();
        if (userData.username === username) {
          setUser({ phone, username });
          setShowPopup(false);
        } else {
          alert("Incorrect username for this phone number.");
        }
      } else {
        await setDoc(doc(db, "UDB", phone), { phone, username });
        setUser({ phone, username });
        setShowPopup(false);
      }
    } catch (error) {
      console.error("Error during login/signup:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleSearch = async () => {
    if (!searchTerm) {
      setSearchResults([]);
      return;
    }

    try {
      let results = [];
      const searchTermLower = searchTerm.toLowerCase();

      for (const collectionName of collections) {
        const colRef = collection(db, collectionName);
        // Fetch up to 100 documents per collection to limit read operations
        const q = query(colRef, limit(100));
        const querySnapshot = await getDocs(q);

        querySnapshot.forEach((doc) => {
          const productData = { id: doc.id, ...doc.data(), Category: collectionName };
          const { ProductID, Brand, Shape, Name, FrameColor } = productData;

          // Case-insensitive partial match for all fields
          if (
            (ProductID && ProductID.toLowerCase().includes(searchTermLower)) ||
            (Brand && Brand.toLowerCase().includes(searchTermLower)) ||
            (Shape && Shape.toLowerCase().includes(searchTermLower)) ||
            (Name && Name.toLowerCase().includes(searchTermLower)) ||
            (FrameColor && FrameColor.toLowerCase().includes(searchTermLower))
          ) {
            // Avoid duplicates
            if (!results.some((result) => result.id === productData.id && result.Category === productData.Category)) {
              results.push(productData);
            }
          }
        });
      }

      setSearchResults(results);
    } catch (error) {
      console.error("Error fetching product details:", error);
      setSearchResults([]);
    }
  };

  // Debounced search function
  const debouncedSearch = debounce(handleSearch, 300);

  useEffect(() => {
    debouncedSearch();
  }, [searchTerm]);

  const handleViewProduct = (product) => {
    navigate(`/product-details`, { state: product });
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  return (
    <>
      <div className="scroll-container text-white">
        <div className="scroll-content">
          {brands.map((b, index) => (
            <div
              key={'brand-1-${index}'}
              className="scroll-item text-center text-lg font-semibold p-2"
            >
              {b}
            </div>
          ))}
        </div>
      </div>

      <div className="md:hidden flex items-center justify-between px-4 py-3 border-b bg-white">
        <button
          className="text-black focus:outline-none"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? (
            <span className="text-2xl">✕</span>
          ) : (
            <span className="text-2xl">☰</span>
          )}
        </button>
        <p className="text-gray-900 text-xl font-bold">Aram Eye Opticals</p>
        <div></div>
      </div>

      <div className="relative min-h-screen md:grid md:grid-cols-[300px_1fr]">
        <div
          className={`fixed md:static top-0 left-0 w-64 bg-gray-800 shadow-lg p-4 h-full z-50 transform transition-transform duration-300 ease-in-out
            ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
        >
          <div className="flex items-center rounded-full justify-between mb-4 md:hidden">
            <h2 className="text-xl font-bold text-gray-100">Categories</h2>
            <button
              onClick={() => setIsSidebarOpen(false)}
              className="bg-black text-white text-2xl p-1 rounded-full inline-flex items-center justify-center"
            >
              <span className="text-white">←</span>
            </button>
          </div>

          <h2 className="text-2xl font-bold mb-4 hidden md:block text-gray-100">Categories</h2>
          <ul className="space-y-2">
            <li className="cursor-pointer hover:text-blue-500 text-gray-100">
              <Link to="/dma">Designer Metal & Metal Frame</Link>
            </li>
            <li className="cursor-pointer hover:text-blue-500 text-gray-100">
              <Link to="/fla">FrameLess</Link>
            </li>
            <li className="cursor-pointer hover:text-blue-500 text-gray-100">
              <Link to="/ffa">Full Frame</Link>
            </li>
            <li className="cursor-pointer hover:text-blue-500 text-gray-100">
              <Link to="/hfa">Half Frame</Link>
            </li>
            <li className="cursor-pointer hover:text-blue-500 text-gray-100">
              <Link to="/sga">Sunglasses</Link>
            </li>
            <li className="cursor-pointer hover:text-blue-500 text-gray-100">
              <Link to="/sa">Safety Glasses</Link>
            </li>
          </ul>

          <div className="mt-8 md:hidden">
            <h2 className="text-xl font-bold mb-4">Quick Links</h2>
            <ul className="space-y-2">
              <li className="cursor-pointer hover:text-blue-500">
                <Link to="/wishlist">Wishlist</Link>
              </li>
              <li className="cursor-pointer hover:text-blue-500">
                <Link to="/cart">Cart</Link>
              </li>
              <li className="cursor-pointer hover:text-blue-500">
                <Link to="/order">Order</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-white p-3 overflow-y-auto">
          <div className="text-center">
            <p className="text-gray-900 text-4xl font-bold mb-4">
              ✨ <span>Welcome to Aram Eye Opticals</span> ✨
            </p>
          </div>

          <div className="hidden rounded-full md:flex items-center justify-between mb-4 bg-gray-900 p-4">
            <div className="flex space-x-6">
              <Link to="/wishlist" className="text-black font-bold text-xl text-gray-100">
                Wishlist
              </Link>
              <Link to="/cart" className="text-black font-bold text-xl text-gray-100">
                Cart
              </Link>
              <Link to="/order" className="text-black font-bold text-xl text-gray-100">
                Order
              </Link>
            </div>
            <div className="flex-1 mx-4">
              <div className="relative">
                <div className="relative inline-block w-3/4">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-full focus:outline-none text-sm"
                  />
                </div>
              </div>
            </div>
            <div>
              {user ? (
                <button
                  onClick={handleLogout}
                  className="bg-gray-100 font-bold px-4 py-2 rounded-full text-gray-900"
                >
                  Logout
                </button>
              ) : (
                <button
                  className="text-black font-bold text-lg text-gray-900 rounded-full bg-gray-100 p-3"
                  onClick={() => setShowPopup(true)}
                >
                  Login / Signup
                </button>
              )}
            </div>
          </div>

          <div className="md:hidden flex flex-col items-center mb-4 space-y-2">
            <div className="w-full max-w-md relative">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search..."
                className="w-full px-4 py-2 border border-gray-300 rounded-full focus:outline-none text-sm"
              />
            </div>
            <div>
              {user ? (
                <button
                  onClick={handleLogout}
                  className="bg-gray-900 text-white px-4 py-2 rounded-full"
                >
                  Logout
                </button>
              ) : (
                <button
                  className="text-black font-bold text-xl"
                  onClick={() => setShowPopup(true)}
                >
                  Login / Signup
                </button>
              )}
            </div>
          </div>

          {searchResults.length > 0 && (
            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-900">Search Results</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {searchResults.map((product) => (
                  <div
                    key={product.id}
                    className="border rounded-lg p-4 cursor-pointer hover:shadow-lg"
                    onClick={() => handleViewProduct(product)}
                  >
                    <img
                      src={product.ImageUrl1}
                      alt={product.ProductID}
                      className="w-full h-48 object-cover rounded mb-2"
                    />
                    <p className="text-gray-900 font-semibold">Product ID: {product.ProductID}</p>
                    <p className="text-gray-600">Category: {product.Category}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="flex-col">
            <Category />
            <Accessories />
            <KidsFrame />
            <KidsSungless />
            <Sunglassess />
            <FullFrame />
            <HalfFrame />
            <DMF />
            <FrameLess />
            <SafetyGlasses />
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-black p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold mb-4 text-white">Login / Signup</h2>
            <div>
              <input
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter phone number"
                className="w-full mb-4 p-2 border border-gray-300 rounded"
              />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                className="w-full mb-4 p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="flex justify-between">
              <button
                onClick={() => setShowPopup(false)}
                className="mt-4 text-black bg-white px-4 w-1/4 rounded-full h-7 rubik-bold"
              >
                Close
              </button>
              <button
                onClick={handleLoginSignup}
                className="bg-white text-black px-4 rounded-full"
              >
                Login / Signup
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}